import axios from "axios";
const auth = require("./auth")
const logger = require("@/utils/logger");
const config = require("config");
const BASE_URL = config.restAPIURL;

export {
  list,
  remove,
  resetQuota,
  stats
};

function list() {
  auth.requireAuthRedirect();
  const url = `${BASE_URL}/superadmin/users`;

  return axios
    .get(url, {
      headers: auth.getHeaders()
    })
    .then(response => {
      return response.data.data;
    })
}

function stats() {
  auth.requireAuthRedirect();
  const url = `${BASE_URL}/superadmin/stats`;

  const start = new Date().getTime()
  return axios
    .get(url, {
      headers: auth.getHeaders()
    })
    .then(response => {
      const stats = response.data.data
      stats.lambda_elapsed = response.headers['x-onestore-elapsed']

      const stop = new Date().getTime()
      stats.http_elapsed = stop - start

      return stats;
    })
}

function remove(email) {
  auth.requireAuthRedirect();
  const url = `${BASE_URL}/superadmin/users/` + encodeURIComponent(email);
  return axios
    .delete(url, {
      headers: auth.getHeaders()
    })
}

function resetQuota(email) {
  auth.requireAuthRedirect();
  const url = `${BASE_URL}/superadmin/quotas/reset`;

  return axios
    .post(url, {
      email: email
    }, {
      headers: auth.getHeaders()
    })
}



// WEBPACK FOOTER //
// ./src/utils/users-api.js